RivalIQ.apps.Insights.module('widgets', function (widgets, App, Backbone, Marionette, $, _) {

    'use strict';

    const ReachView = RivalIQ.views.LayoutView.mixin({
        template: '#instagramStoriesReachTemplate',
        childView: RivalIQ.apps.Dashboard.views.Widget,

        mixins: {
            props: Marionette.Dashboard.mixins.Props
        },

        dashboardModelEvents: {
            'change': 'reload'
        },

        regions: {
            summaryMetric: '.x-summary-metric',
            summaryRateMetric: '.x-summary-rate-metric',
            barChart: '.x-bar-chart'
        },

        onBeforeRenderLoaded: function () {
            const me = this;

            me.summaryMetric.showWidget(me.dashboardModel.getWidget('summary-metric'));
            me.summaryRateMetric.showWidget(me.dashboardModel.getWidget('summary-rate-metric'));

            me.barChart.showWidget(me.dashboardModel.getWidget('bar-chart'));
        },

        serializeData: function () {
            const me = this;

            const reachBarLabel = `Peak Reach Per ${RivalIQ.utils.timePeriod.interval[me.getProp('interval')]}`;

            return {
                reachBarLabel: reachBarLabel
            };
        }
    });

    const PanelWithGroupBy = RivalIQ.apps.Dashboard.views.Panel.extend({

        showActions: function () {
            const me = this;

            me.showGroupByDropdown();

            RivalIQ.apps.Dashboard.views.Panel.prototype.showActions.apply(me, arguments);
        },

        showGroupByDropdown: function () {
            const me = this;

            me.actions.show(new RivalIQ.apps.Dashboard.views.IntervalDropdown({
                dashboardModel: me.dashboardModel
            }), {
                preventDestroy: true
            });
        }
    });

    const RetentionWidget = RivalIQ.apps.Dashboard.models.Widget.mixin({

        panelView: PanelWithGroupBy,

        mixins: {
            userSettingsChanged: RivalIQ.apps.Dashboard.mixins.UserSettingsChanged
        },

        propsToSerializeForExport: ['interval'],

        getExportTitle: App.utils.insightsExportTitle,
        getExportSubtitle: App.utils.insightsExportSubtitle,
        getPptSubtitle: App.utils.insightsPptSubtitle,
        scheduledExportAdvancedSettingsEnabled: false,

        title: 'Peak Reach',
        description: RivalIQ.strings.instagram_insights_peak_reach_widget_description,
        view: ReachView,
        viewMore: false,

        onUserSettingsChanged: function () {
            const me = this;

            const intervalStr = RivalIQ.apps.Dashboard.views.IntervalDropdown.getGroupByInterval(me.getProps());
            const interval = RivalIQ.apps.SocialPosts.utils.fixIntervalForMetric(intervalStr);
            me.setProps('interval', interval);
        },

        processProps: function (props) {
            const me = this;

            _.defaults(props, {
                objectType: RivalIQ.enums.insightsObjectType.storyDay,
                submetricType: 'delta_relative'
            });

            props.submetricDisplayType = 'upDownCarets';

            if (!me.isExporting()) {
                const intervalStr = RivalIQ.apps.Dashboard.views.IntervalDropdown.getGroupByInterval(props);
                props.interval = RivalIQ.apps.SocialPosts.utils.fixIntervalForMetric(intervalStr);
            }

            if (!me.metric) {
                me.metric = App.utils.createInsightsMetric(props.objectType, _.defaults({
                    dimensions: ['timeAnalysisMode', 'channel', 'companyId']
                }, props));
            }
            _.extend(me.metric, props);

            return props;
        },

        widgetDefinitions: function () {
            const me = this;
            const props = me.getProps();

            const metric = new RivalIQ.models.MetricDefinition(me.metric);
            return [
                {
                    instanceId: 'summary-metric',
                    widgetId: RivalIQ.enums.widgetTypes.METRIC,
                    metric: metric.build({
                        property: 'max_reach_per_day',
                        companyId: props.companyId
                    }),
                    submetric: metric.build({
                        property: 'max_reach_per_day',
                        timeAnalysisMode: RivalIQ.enums.timeAnalysisMode.DELTA_RELATIVE
                    })
                },
                {
                    instanceId: 'summary-rate-metric',
                    widgetId: RivalIQ.enums.widgetTypes.METRIC,
                    metric: metric.build({
                        property: 'max_reach_rate',
                        companyId: props.companyId
                    }),
                    submetric: metric.build({
                        property: 'max_reach_rate',
                        timeAnalysisMode: RivalIQ.enums.timeAnalysisMode.DELTA_RELATIVE
                    })
                },
                {
                    instanceId: 'bar-chart',
                    widgetId: RivalIQ.enums.widgetTypes.INSIGHTS_METRIC_BAR_CHART
                }
            ];
        }
    });

    Marionette.Dashboard.widgets.add(RivalIQ.enums.widgetTypes.INSTAGRAM_INSIGHTS_STORIES_REACH, RetentionWidget);
});
